<template>
  <div id="app" class="" style="display: flex;flex-direction: column;">
      <div id="sb_site" class="" style="">
       <NavBar></NavBar>
       <transition name="fade" mode="out-in"><router-view/></transition>
       
      </div>
      <PageFooter></PageFooter>
  </div>
</template>

<script>

import NavBar from './components/NavBar.vue'
import PageFooter from './components/PageFooter.vue'

export default {
  name: 'app',
  components: {
    NavBar,
    PageFooter
  }
}
</script>

<style>

.fade-enter-active, .fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}


</style>
